import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios";



export const loadJobPositions = async () => {
  try {
    const response = await Axios.get('job-positions');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadJobPosition = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/job-positions');
        // const requestData = await response.data;
        // return {...requestData, jobPosition: {}};
        return {jobPosition: {}};
        
      default:
        const respnse = await Axios.get('job-positions/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useJobPositionAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('job-positions', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('job_position_response', responseData.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('job-positions/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('job_position_response', responseData.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useJobPositionAPI;


